import { render, staticRenderFns } from "./consult-card.vue?vue&type=template&id=68a00ab7&scoped=true&"
import script from "./consult-card.vue?vue&type=script&lang=js&"
export * from "./consult-card.vue?vue&type=script&lang=js&"
import style0 from "./consult-card.vue?vue&type=style&index=0&id=68a00ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a00ab7",
  null
  
)

export default component.exports